import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'title',
  standalone: false,
})
export class TitlePipe implements PipeTransform {
  transform(values: any | any[], seperator: string = '_'): any {
    const isArray = Array.isArray(values);
    const result = [];
    (isArray ? values : [values]).forEach((val) => {
      const words = (val || '').split(seperator);
      result.push(
        words
          .map((word) => {
            return word[0]?.toUpperCase() + word?.substring(1);
          })
          .join(' '),
      );
    });
    return isArray ? result : result[0];
  }
}
